const scrollToContentStickyNavigations = (isBestSeller, offset = -49) => {
  const contentStickyNavigations = isBestSeller
    ? document.getElementById('best-sellers-navigations-scroll-point')
    : document.getElementById('content-sticky-navigations-scroll-point')

  if (contentStickyNavigations) {
    const y =
      contentStickyNavigations.getBoundingClientRect().top +
      window.pageYOffset +
      offset

    window.scrollTo(0, y)
  }
}
export default scrollToContentStickyNavigations
